import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { SessionManager } from '@/lib/sessionManager';

/**
 * Hook to enforce temporary session security
 * Automatically signs out users when they reopen their browser
 * after closing it with a temporary session
 */
export function useSessionSecurity() {
  useEffect(() => {
    const checkAndCleanupSession = async () => {
      if (SessionManager.shouldTerminate()) {
        console.log('[Security] Cleaning up temporary session after browser restart');

        try {
          await supabase.auth.signOut();
        } catch (error) {
          console.error('[Security] Error signing out:', error);
        } finally {
          SessionManager.cleanup();
        }
      }
    };

    checkAndCleanupSession();
  }, []);
}
